import {ReactNode} from "react";

import {Card} from "@/components/card/Card.tsx";

import styles from "./CTABanner.module.scss";

interface CTABannerProps {
  left: ReactNode;
  middleText: ReactNode;
  middleButton: ReactNode;
  right: ReactNode;
}

export const CTABanner = ({left, middleText, middleButton, right}: CTABannerProps) => {
  return (
    <Card variant="marketing" className={styles.ctaBannerCard}>
      <div className={styles.ctaBanner}>
        {left}
        <div className="flex-grow-1">
          <div className={styles.ctaBannerMiddleText}>{middleText}</div>
          {middleButton}
        </div>
        {right}
      </div>
    </Card>
  );
};
